"use strict";
/**
 * Product Helper Functions
 * -----------------------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
function lineItemTitle(lineitemTitle, needles) {
    var title = lineitemTitle;
    needles.forEach(function (needle) {
        if (needle.length > 2) {
            title = title.replace(needle, "");
        }
    });
    return title.trim().replace(/-$/, "");
}
exports.lineItemTitle = lineItemTitle;
